export default "__VITE_ASSET__XH7YIr9y__"